import { gql } from 'graphql.macro';

// DD-3726: whether the caller's lab may send electronic invoices, and what it lacks.
export const labEInvoicingTemplate = gql`
    query labEInvoicing {
        labEInvoicing {
            enabled
            enabledAt
            migrated
            requirements
            canEnable
            supportedCountries
        }
    }
`;

// DD-3726: the last stored Crediflow answer for one customer (no Crediflow call).
export const customerEInvoicingTemplate = gql`
    query customerEInvoicing($clientId: MongoDbObjectId!) {
        customerEInvoicing(clientId: $clientId) {
            status
            receiverPartyId
            organizationNumber
            countryCode
            gln
            checkedAt
            invite {
                id
                type
                email
                status
                sentAt
            }
        }
    }
`;
